import { render, staticRenderFns } from "./TabColor.vue?vue&type=template&id=09200db2&"
import script from "./TabColor.vue?vue&type=script&lang=js&"
export * from "./TabColor.vue?vue&type=script&lang=js&"
import style0 from "./TabColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports